export default "__VITE_ASSET__CCDOVc_h__"